// extracted by mini-css-extract-plugin
export default {"LeadP":"LeadP_LeadP__HH+jb","Bold":"LeadP_Bold__F0Cup","MbSmall":"LeadP_MbSmall__APg3m"};